;
define("global_views_showing_current.tpl", function(){});

